import React from "react";

export default function LogoPreviewPage() {
  return (
    <div style={{ padding: 40, fontFamily: "'Trebuchet MS', sans-serif", color: "#8ab4d0" }}>
      <p>Logo preview — coming soon.</p>
      <a href="/" style={{ color: "#00b4ff" }}>← Back to site</a>
    </div>
  );
}
